// tutorial: esponiamo le route di vue-router e impostiamo i componenti che renderizzano la view
import Vue from 'vue';
import Router from 'vue-router';
import Cart from './views/Cart.vue';
import Login from './views/Login.vue';
import Checkout from './views/Checkout.vue';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      switch (to.hash) {
        case '#invoice-data':
          return { x: 0, y: 460 };
        default:
          return { selector: to.hash };
      }
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (cart.isEmpty) {
          return next({path: '/'});
        } else if (user.isLoggedin) {
          return next({path: '/checkout'});
        } else {
          return next();
        }
      },
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      beforeEnter: (to, from, next) => {
        if (cart.isEmpty) {
          return next({path: '/'});
        } else {
          return next();
        }
      },
    },
  ],
});
